<template>
    <div
        :class="[classStyles['bg-secondary_color-500'], styles['dropdown_element']]"
        class="fixed right-0 z-10 m-auto mr-4 flex flex-col justify-between bg-red-500/60 p-1 backdrop-blur-3xl sm:mt-0 md:p-1.5"
    >
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'BaseSideNavigation',
  data () {
    return {
      classStyles: window.class_styles,
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
